import { render, staticRenderFns } from "./deleteItem.vue?vue&type=template&id=7dce04f0&"
import script from "./deleteItem.vue?vue&type=script&lang=js&"
export * from "./deleteItem.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports